// removed by extract-text-webpack-plugin
module.exports = {"jsi-logo":"JsiLogo__jsi-logo__3naMF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JsiLogo/JsiLogo.scss
// module id = 431
// module chunks = 0